import React from "react";
import { ensure } from "sprint-common-web";

import { RecordType } from "../../../../../common/types/RecordType";
import { AssetsAvailabilityList } from "../../../../common/components/listings/AssetsAvailabilityList";
import { OrderAssetAvailability } from "../../../../common/types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../../../common/types/OrderAssetStorageType";
import { OrderRequestListingItem } from "../../OrderRequestListingItem";

export const renderOrderRequestSubtitles = (item?: OrderRequestListingItem): JSX.Element => {
    ensure(item);

    const hasAnyCloudAssetAvailable = item.subtitles.cloud.some((subtitle) =>
        [OrderAssetAvailability.FullMatch, OrderAssetAvailability.PartialMatch].includes(subtitle.availability)
    );

    if (hasAnyCloudAssetAvailable) {
        return (
            <AssetsAvailabilityList
                items={item.subtitles.cloud}
                type={OrderAssetStorageType.Cloud}
                testId={"order-requests-subtitles-availability-status"}
                isTrailer={item.isTrailer}
                requiredSubtitleTypes={item.requestedSubTypes}
                assetType={RecordType.Subtitle}
            />
        );
    }

    return (
        <AssetsAvailabilityList
            items={item.subtitles.onPrem}
            type={OrderAssetStorageType.OnPrem}
            testId={"order-requests-subtitles-availability-status"}
            isTrailer={item.isTrailer}
            assetType={RecordType.Subtitle}
        />
    );
};
